import { useState, useEffect } from "react";
import UserService from "../../services/UserService/UserService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function useUserFetch(userId, dependencies = []) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  let allDependencies = [];
  const baseDependencies = [userId, setUser, setIsLoading];

  if (dependencies.length === 0) {
    allDependencies = baseDependencies;
  } else {
    allDependencies = baseDependencies.concat(dependencies);
  }

  useEffect(() => {
    async function fetchUser() {
      if (typeof userId === "undefined") {
        setIsLoading(false);
        navigate("/users");
        return;
      }
      setIsLoading(true);
      const newUser = await UserService.getUser(userId);
      setIsLoading(false);

      if (newUser) {
        setUser(newUser);
      } else {
        toast.error("Unable to find user.");
        navigate("/users");
      }
    }

    fetchUser();
  }, allDependencies);

  return {
    user,
    setUser,
    isLoading,
    setIsLoading,
  };
}

export default useUserFetch;
